<template>
  <b-link v-if="isLink"
          @click="click()"
          class="input-link"
          :class="getCustomClass()"
          :style="styles"
  >
    <div :class="{'d-flex justify-content-center': !session.is_legacy}">
      <div :class="{'reject_button_width': !session.is_legacy}" v-html="sessionInputLabel"></div>
    </div>
  </b-link>
  <button v-else
          @click="click()"
          class="btn-base input-choice-btn"
          :class="getCustomClass(true)"
          :style="styles"
  >
    <div :class="{'d-flex justify-content-center': !session.is_legacy}">
      <div :class="{'accept_button_width': !session.is_legacy}" v-html="sessionInputLabel"></div>
    </div>
  </button>
</template>

<script>
import {mapState} from 'vuex'
import {InputType, StepButtonType} from '@/constants'
import {getCustomInputClass, updateFontSizes} from '@/utils'

export default {
  name: 'InputButton',
  props: {
    input: Object
  },
  computed: {
    ...mapState(['isIE', 'session']),
    isLink: function() {
      return this.input.type === InputType.Link ||
        (this.input.button_styles && this.input.button_styles.style_type === StepButtonType.TextOnly)
    },
    styles: function() {
      return this.input && this.input.button_styles && this.input.button_styles.style
    },
    sessionInputLabel() {
      return updateFontSizes(this.input.formatted_label)
    }
  },
  methods: {
    click: function() {
      this.$emit('click')
    },
    getCustomClass: function(includeButtonClass = false) {
      return getCustomInputClass(this.session, this.input, includeButtonClass)
    }
  }
}
</script>

<style scoped>

</style>
